<template>
  <div class="detialBox mt-h">
    <div class="detial container" id="container">
      <div class="pagenav py-1">
        <span class="go_home" @click="goHomeFn">Home</span> >
        {{ liveTitle.value }}
      </div>
      <!-- banner -->
      <div class="detial-banner">
        <div id="player_box" ref="play_box"></div>
      </div>
      <div class="detial-info">
        <div class="detial-info__title">
          <img class="title-icon" src="@/assets/imgs/live/live_icon.png" />{{
            liveTitle.value
          }}
        </div>
      </div>
      <div class="related">
        <div class="article-btn">RELATED ARTICLES</div>
      </div>
      <!--  article-list -->
      <ArticleList
        v-if="artilcleList"
        :artilcleList="artilcleList"
      ></ArticleList>

      <!-- loadmore -->
      <div class="w-100 morebox py-2">
        <div class="loadmore" @click="loadMoreFn">
          <span class="loadmore-txt pr-1">Load more</span>
          <b-icon icon="chevron-down"></b-icon>
        </div>
        <BackTop class="phoneback"></BackTop>
      </div>
    </div>
    <Footer></Footer>
    <div
      class="model_box"
      :class="{ post_model: showModel }"
      v-if="isShowModel && artilcleList.length > 0"
    >
      <div class="top_title">
        <i class="el-icon-close" @click="isShowModel = false"></i>
        <span class="tit_txt">MORE STORIES</span>
      </div>
      <div class="img_box" @click="gotoDetail(artilcleList[0]['postId'])">
        <img :src="setImgFn(artilcleList[0]['sourceUrl'])" alt="" />
      </div>
      <div class="dec_txt" @click="gotoDetail(artilcleList[0]['postId'])">
        {{ artilcleList[0]["postTitle"] }}
      </div>
    </div>
    <div class="imgDialog" v-if="hbDialog">
      <div class="img_box">
        <img
          class="close_img"
          @click="close_model"
          src="@/assets/imgs/detial/close_icon.png"
          alt=""
        />
        <img class="hb_img" :src="postImg" alt="" />
      </div>
    </div>
    <div class="weixin_box" v-if="isShowWx" @click="isShowWx = false">
      <img class="hint_img" src="@/assets/imgs/weShare.jpg" alt="" />
    </div>
    <div id="fb-root"></div>
  </div>
</template>

<script>
// import DetialIcon from "./detialchild/DetialIconGroup.vue";
// import Artical from "./detialchild/Artical.vue";
import ArticleList from "../detial/detialchild/ArticleList.vue";
import Share from "@/components/common/model/share.vue";
import Footer from "@/components/common/layout/Footer.vue";
import BackTop from "@/components/common/return/return.vue";
import { getMoreData, getLiveUrl } from "@/network/details.js";
import Cover from "@/assets/imgs/live/cover.png";

import VideoTrack from "@/utils/track/content/video.js";

export default {
  name: "Detial",
  components: {
    // DetialIcon,
    // Artical,
    ArticleList,
    Footer,
    BackTop,
    Share,
  },
  data() {
    return {
      postId: "",
      liveShow: {
        id: undefined,
        code: "live_show",
        value: "0",
      },
      liveImage: {
        id: undefined,
        code: "live_image",
        value: "",
      },
      liveUrl: {
        id: undefined,
        code: "live_url",
        value: "",
      },
      liveTitle: {
        id: undefined,
        code: "live_title",
      },
      detailsInfo: {
        type: "直播",
        postTitle: "ShanghaiEye English｜LIVE 24",
        sourceUrl: "https://liveplay.shanghaieye.cn/live/24h.m3u8",
        cover: Cover,
      },
      livePullUrl: "",
      artilcleList: [],
      indexNub: 3,
      viewData: [],
      realArr: "",
      aaa: "",
      showModel: false,
      page: 1,
      isShowModel: true,
      postImg: "",
      hbDialog: false,
      isShowWx: false,
      source: {},
      isLive: true,
      playerHeight: 400,
      coverImg: "",
      showShareModel: false,
      previewPostId: "", //预览的标志

      // start 埋点所需
      videoTrack: null,
      // end 埋点所需
    };
  },
  created() {},
  computed: {
    setImgFn() {
      return function(url) {
        if (url) {
          let index = url.lastIndexOf(".");
          let tempUrl = url.slice(0, index) + "_related" + url.slice(index);
          return tempUrl;
        }
      };
    },
    // start 埋点所需数据
    trackData() {
      return {
        content_id: this.liveTitle.value,
        content_name: this.detailsInfo.postTitle,
        content_form: "live",
        live_status: 1,
        file_type: 1,
        current_page: "直播页面",
        utm_source: "本站跳转",
      };
    },
    // end 埋点所需数据
  },
  mounted() {
    // start 埋点所需
    this.videoTrack = new VideoTrack();
    // end 埋点所需
    this.postId = this.$route.query.postId;
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
    this.getArticel();
    this.setPlayerheight();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getData() {
      this.$nextTick(() => {
        this.$store.dispatch("getWebConfig").then((res) => {
          console.log("dispatch: ", res);
          if (res.liveShow.value === "0") {
            this.$router.replace({
              path: "/",
            });
            return;
          }
          this.liveShow = res.liveShow;
          this.liveImage = res.liveImage;
          this.liveTitle = res.liveTitle;
          this.liveUrl = res.liveUrl;
          // this.initAly();
          getLiveUrl().then((res) => {
            // console.log("getLiveUrl: ", res);
            this.livePullUrl = res.data.hlsUrl;
            this.initAly();
          });
        });
      });
    },
    // 动态计算阿里云播放器的高度
    setPlayerheight() {
      var container = document.getElementById("container");
      if (container.clientWidth > 750) {
        this.playerHeight = (container.clientWidth - 30) / (16 / 9) + "px";
        console.log(this.playerHeight, "playerHeight111");
      } else {
        this.playerHeight = container.clientWidth / (16 / 9) + "px";
        console.log(this.playerHeight, "playerHeight222");
      }
      // console.log(alHeight.clientWidth-30, "12222222");
    },
    goHomeFn() {
      this.$router.push("/home").catch((err) => {
        err;
      });
    },
    initAly() {
      // 封面图
      var _this = this;
      var aliplayer = new Aliplayer(
        {
          id: "player_box",
          source: this.livePullUrl,
          cover: this.liveImage.value, //播放器封面图
          width: "100%",
          // height: "300px",
          height: this.playerHeight,
          autoplay: true,
          isLive: this.isLive,
          rePlay: true,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
          defaultDefinition: "SD",
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "cc",
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "thumbnail",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "setting",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 10,
                  y: 10,
                },
              ],
            },
          ],
        },
        function(player) {
          // console.log("The player is created");
          _this.videoTrack.add({
            value: _this.trackData,
            dom: _this.$refs.play_box.querySelector("video"),
          });
          // _this.setPlayerheight();
          // player.mute()
          // player.play()
        }
      );
      aliplayer.on("play", () => {
        console.log("play");
        // aliplayer.mute(false)
        // setTimeout(() => {
        //   aliplayer.setVolume(0.5)
        // }, 1000)
      });
    },
    gotoDetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: id,
        },
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 100) {
        this.showModel = true;
      } else {
        this.showModel = false;
      }
    },
    loadMoreFn() {
      this.page++;
      this.getArticel();
      // this.indexNub = this.indexNub + 3;
    },
    getArticel() {
      getMoreData({ page: this.page, size: 3, postId: this.postId || 0 }).then(
        (res) => {
          // console.log(res, "resresrser");
          this.artilcleList = this.artilcleList.concat(res.data);
        }
      );
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less">
@keyframes fade {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.detialBox {
  .prism-player .prism-big-play-btn {
    position: absolute;
    left: 50% !important;
    top: 50% !important;
    display: block;
    transform: translate(-50%, -50%);
  }
  .prism-player .prism-ErrorMessage .prism-error-operation a {
    font-size: 16px;
  }
  img {
    // width: 100%;
    height: auto;
  }
  .pcback,
  .phoneback {
    display: none;
  }
  .pagenav {
    color: #c3c3c3;
    font-size: 16px;
    font-family: Open Sans;
    .go_home {
      cursor: pointer;
      &:hover {
        color: #666;
      }
    }
  }
  .detial {
    &-info {
      padding: 0.5rem 0.5rem;
      &__title {
        font-size: 0.5rem;
        font-family: FranklinGothic-Demi;
        font-weight: 400;
        color: #2f2f2f;
        line-height: 0.5rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        .title-icon {
          width: 15px;
          height: 15px;
          line-height: 0.5rem;
          vertical-align: baseline;
          margin-right: 10px;
          animation: fade 1.5s linear 0s infinite;
        }
      }
    }
    .related {
      // margin-bottom: 10px;
      height: 0.9rem;
      font-size: 14px;
      // font-family: Calibri;
      // width: calc(100% - 0.5rem);
      margin-bottom: 10px;
      border-bottom: 2px solid #53a1dc;
      .article-btn {
        font-weight: bold;
        background: #53a1dc;
        height: 0.9rem;
        line-height: 0.9rem;
        width: 4rem;
        text-align: center;
        color: #ffffff;
      }
    }
    .morebox {
      clear: both;
      width: 100%;
    }
    .loadmore {
      // border-radius: 5px;
      font-size: 12px;
      color: #929292;
      font-family: Open Sans;
      // font-weight: bold;
      cursor: pointer;
      line-height: 0.3rem;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      width: 3rem;
      line-height: 0.7rem;
      text-align: center;
      border: 1px solid #ccc;
      padding: 0.1rem 0.1rem 0.1rem 0.2rem;
      text-align: center;
    }
  }
  .model_box {
    position: fixed;
    right: -345px;
    bottom: 120px;
    border: 1px solid #ededed;
    width: 340px;
    background-color: #fff;
    padding: 20px;
    z-index: 100;
    transition: all 0.5s cubic-bezier(0.265, 0.365, 0.26, 0.865);
    &.post_model {
      right: 0;
    }
    .top_title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      i {
        font-size: 18px;
        padding: 0 8px;
        font-weight: bold;
        cursor: pointer;
      }
      .tit_txt {
        flex: 1;
        font-family: "Open Sans", arial, sans-serif;
        color: #222;
        font-size: 17px;
        font-weight: 600;
        line-height: 30px;
        display: inline-block;
        text-align: center;
      }
    }
    .img_box {
      width: 100%;
      height: 167px;
      margin-bottom: 10px;
      cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .dec_txt {
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      &:hover {
        color: #4db2ec;
      }
    }
  }
  .imgDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #eaeaea;
    z-index: 6666;
    // display: flex;
    // align-content: center;
    // justify-content: center;
    .img_box {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .close_img {
        width: 36px;
        height: 36px;
        position: absolute;
        right: -14px;
        top: -16px;
        z-index: 6666;
      }
      .hb_img {
        width: 100%;
        display: block;
        margin-top: 22px;
      }
    }
  }
  .weixin_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 6666;
    .hint_img {
      // width: 100%;
      // max-width:400px;
      height: 100vh;
      margin: 0 auto;
      display: block;
    }
  }
}

@media screen and (min-width: 768px) {
  .detialBox {
    .imgDialog {
      display: none;
    }
    #player_box {
      // height: 400px !important;
    }
    .pcback {
      display: block;
    }
    .loadmore {
      border-radius: 1px;
      font-size: 12px;
      color: #929292;
      font-family: FranklinGothic-Demi;
      // font-weight: bold;
      cursor: pointer;
      line-height: 0.2rem !important;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      text-align: center;
      border: 1px solid #ccc;
      width: 1.6rem !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .detialBox {
    .model_box {
      display: none;
    }
    .container {
      margin: 0 auto !important;
    }
    #player_box {
      width: 100%;
      // height: 300px;
    }
    .morebox {
      position: relative;
    }
    .phoneback {
      position: absolute;
      display: block;
      transform: translate(0, 50%);
    }
    .container {
      width: 100% !important;
      padding: 0;
      margin: 0;
      // margin-top: 1.3rem;
    }
    .pagenav {
      display: none;
      padding-top: 0;
    }
    .related {
      margin-bottom: 10px !important;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
